import { useUserProvider } from "./provider";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import "./index.css";
import { BsSendFill } from "react-icons/bs";
import { TbHeart, TbMailFilled } from "react-icons/tb";
import { useReportManager } from "../../wrappers/report";
/**
 *
 * @param {import("@chakra-ui/react").ButtonProps & import("./props").UserProps} props
 * @returns
 */
const ConnectButton = (props) => {
  const user = useUserProvider();
  const { triggerFanMail, triggerBusinessQuery } = useReportManager();

  return (
    <Menu placement="bottom">
      <MenuButton
        as={Button}
        borderRadius={'full'}
        size="sm"
        variant={"glow"}
        leftIcon={<BsSendFill />}
        fontSize={'xs'}
        {...props}
      >
        Connect
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => triggerFanMail(user)}>
          <TbHeart />
          Send a fan-mail
        </MenuItem>
        <MenuItem onClick={() => triggerBusinessQuery(user)}>
          <TbMailFilled />
          Send business inquiry
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ConnectButton;
